<!--
    描述：签证对比 --- vxe-table 版本
    时间：2021-12-3
    Created by yef
-->
<template>
    <div class="h100">
        <vxe-table :loading="loading" border highlight-hover-row highlight-current-row ref="xTable" auto-resize resizable align="center" height="auto" size="small" show-footer  :sort-config="{ trigger: 'cell' }" @header-cell-click="onHeaderClick">
            <vxe-column type="seq" width="70" title="序号" sortable></vxe-column>
            <!-- 对比列 1 -->
            <vxe-colgroup field="type1">
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select v-model="visaType1" size="small">
                        <el-option v-for="(item, index) in visaTypeList" :key="'价格类别1' + index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>

                <!-- 全部分类 -->
                <vxe-column v-for="(item, index) in compareArr1" :key="'筛选列' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow" :filters="[{ data: '' }]" :filter-method="item.filterMethods" :header-class-name="item.needFilter ? 'needFilter' : 'hideFilter'">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select multiple filterable ref="filterSelect" collapse-tags popper-class="drop-poper" :popper-append-to-body="false" v-model="option.data" v-for="(option, inx) in column.filters" :key="item.key + inx" @change="$panel.changeOption($event, !!option.data, option)">
                            <el-option v-for="(m, n) in listData[item.key]" :key="n" :label="m.text" :value="m.value"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
            </vxe-colgroup>
            <vxe-column title="单位工程名称" header-align="center" align="left" sortable show-overflow min-width="200">
                <template #default="{ row }">
                    <span>{{ row.str2.treeName }}</span>
                </template>
            </vxe-column>
            <!-- 对比列 2 -->
            <vxe-colgroup field="type2">
                <!-- 自定义合并头部 -->
                <template #header>
                    <el-select v-model="priceType2" size="small">
                        <el-option v-for="(item, index) in priceTypeList" :key="'价格类别2' + index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </template>
                <!-- 全部分类 -->
                <vxe-column v-for="(item, index) in compareArr2" :key="'筛选列2' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow" :filters="[{ data: '' }]" :filter-method="item.filterMethods" :header-class-name="item.needFilter ? 'needFilter' : 'hideFilter'">
                    <!-- 如果需要渲染的 -->
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                    <!-- 如果需要筛选的 -->
                    <template #filter="{ $panel, column }">
                        <el-select multiple filterable ref="filterSelect" collapse-tags popper-class="drop-poper" :popper-append-to-body="false" v-model="option.data" v-for="(option, inx) in column.filters" :key="item.key + inx" @change="$panel.changeOption($event, !!option.data, option)">
                            <el-option v-for="(m, n) in listData[item.key]" :key="n" :label="m.text" :value="m.value"></el-option>
                        </el-select>
                    </template>
                </vxe-column>

                <!-- 旧版本 -->
                <!-- <vxe-column v-for="(item, index) in listData.filterArr2" :key="'筛选列' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow" :filters="[{ data: '' }]" :filter-method="item.filterMethods">
                    // 如果需要渲染的
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                    // 如果需要筛选的
                    <template #filter="{ $panel, column }">
                        <el-select multiple filterable ref="filterSelect" collapse-tags popper-class="drop-poper" :popper-append-to-body="false" v-model="option.data" v-for="(option, inx) in column.filters" :key="item.key + inx" @change="$panel.changeOption($event, !!option.data, option)">
                            <el-option v-for="(m, n) in listData[item.key]" :key="n" :label="m.text" :value="m.value"></el-option>
                        </el-select>
                    </template>
                </vxe-column>
                <vxe-column v-for="(item, index) in listData.normalArr2" :key="'筛选列2' + index" :title="item.label" :field="item.key" :visible="item.visible" :width="item.width" :min-width="item.minWidth" :align="item.align" :header-align="item.headerAlign" :sortable="item.sortable" :show-overflow="item.showOverFlow">
                    // 如果需要渲染的
                    <template #default="{ row }" v-if="item.needRender">
                        <span>{{ item.render(row) }}</span>
                    </template>
                </vxe-column> -->
            </vxe-colgroup>
        </vxe-table>
        <!-- 列过滤弹窗 -->
        <el-dialog :title="dialogObj.title" :visible.sync="dialogObj.visible" :width="dialogObj.width" :close-on-click-modal="false" @closed="handleClose">
            <!-- 列过滤 -->
            <div class="text-center h100 overflow-hidden" v-if="dialogObj.visible && dialogObj.type === 'filter'">
                <!-- 对比列筛选 -->
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">{{ getPhaseObj.name1 }}
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr1')" v-model="checkAll.compare1">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr1" :label="item.key" :key="'对比列1' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <el-row class="check-row">
                    <el-col :span="4" class="check-name text-overflow">{{ getPhaseObj.name2 }}
                        <el-checkbox class="ml10" @change="handleAllChange($event, 'compareArr2')" v-model="checkAll.compare2">全选
                        </el-checkbox>
                    </el-col>
                    <el-col :span="20" class="check-content">
                        <el-checkbox v-for="(item, index) in compareArr2" :label="item.key" :key="'对比列2' + index" v-model="item.visible">{{ item.label }}
                        </el-checkbox>
                    </el-col>
                </el-row>
                <!-- 确认取消按钮 -->
                <div slot="footer" class="dialog-footer text-center">
                    <el-button @click="dialogObj.visible = false" size="small">取 消
                    </el-button>
                    <el-button type="primary" size="small" :loading="btnLoading" @click="doFilter">确 定
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getVisaConditions, getVisaData} from "@/api/modules/analysisDetail";

export default {
    name: "",
    data() {
        return {
            loading: false,
            visaType1: "1055001", // 默认签证报审价
            priceType2: "1007002", // 默认控制价
            visaTypeList: [], //左侧签证阶段下拉框数据
            priceTypeList: [], //右侧六算阶段下拉框数据
            curColumn: '', // 当前点击的列 property
            allTableData: [], // 全部数据
            // 暂存的 当前参数
            queryParams: {},
            // 列过滤弹窗
            dialogObj: {
                title: "列过滤",
                visible: false,
                width: "1000px",
                type: "filter",
                exportExcel: false,
            },
            btnLoading: false,
            allColumns: [],
            // 全选
            checkAll: {
                compare1: false,
                compare2: false,
                reasons: true,
                compare3: true,
                compare4: true,
            },
            filterObj: {
                codeArr: [], // 当前绑定的编码数组
                names1: [], // 左侧清单名称过滤数组
                units1: [], // 左侧计量单位过滤数组
                names2: [], // 右侧清单名称过滤数组
                units2: [], // 右侧计量单位过滤数组
            },
            // 对比价格1 列
            compareArr1: [
                {
                    label: "清单编码",
                    key: "str1.code",
                    visible: true,
                    width: "200",
                    align: "center",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "清单名称",
                    key: "str1.projectName",
                    visible: true,
                    width: "200",
                    minWidth: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str1.projectName2);
                    },
                },
                {
                    label: "清单特征",
                    key: "str1.projectFeatures",
                    visible: false,
                    minWidth: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "计量单位",
                    key: "str1.unit",
                    visible: true,
                    width: "110",
                    minWidth: "0",
                    align: "center",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str1.unit2);
                    },
                },
                {
                    label: "工程量",
                    key: "str1.quantity",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return row.str1.hideFlag === 0 ? this.NumberToFixed(row.str1.quantity, 3) : "-"
                    }
                },
                {
                    label: "综合单价",
                    key: "str1.rateCost",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return row.str1.hideFlag === 0 ? this.NumberToFixed(row.str1.rateCost, 2) : "-"
                    }
                },
                {
                    label: "合价",
                    key: "str1.addup",
                    visible: true,
                    width: "120",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return row.str1.hideFlag === 0 ? this.NumberToFixed(row.str1.addup, 2) : "-"
                    }
                },
            ],
            // 对比价格2 列
            compareArr2: [
                {
                    label: "清单编码",
                    key: "str2.code",
                    visible: true,
                    width: "200",
                    align: "center",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "清单名称",
                    key: "str2.projectName",
                    visible: true,
                    width: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str2.projectName);
                    },
                },
                {
                    label: "清单特征",
                    key: "str2.projectFeatures",
                    visible: false,
                    width: "200",
                    align: "left",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: false,
                },
                {
                    label: "计量单位",
                    key: "str2.unit",
                    visible: true,
                    width: "110",
                    minWidth: "0",
                    align: "center",
                    headerAlign: "center",
                    sortable: false,
                    showOverFlow: true,
                    needFilter: true,
                    filterMethods: ({ option, row }) => {
                        return option.data.includes(row.str2.unit);
                    },
                },
                {
                    label: "工程量",
                    key: "str2.quantity",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str2.quantity, 3)
                    }
                },
                {
                    label: "综合单价",
                    key: "str2.rateCost",
                    visible: true,
                    width: "100",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str2.rateCost, 2)
                    }
                },
                {
                    label: "合价",
                    key: "str2.addup",
                    visible: true,
                    width: "120",
                    align: "right",
                    headerAlign: "center",
                    sortable: true,
                    showOverFlow: true,
                    needRender: true,
                    needFilter: false,
                    render: (row) => {
                        return this.NumberToFixed(row.str2.addup, 2)
                    }
                },
            ],
        };
    },
    created() {
        // 获取期数含价格的类型数组
        this.getPriceList()
    },
    methods: {
        // 初始获取期数
        getPriceList() {
            this.priceTypeList = [];
            this.visaTypeList = [];
            getVisaConditions({
                    id: this.curProjectId,
                })
                .then((res) => {
                    this.priceTypeList = res.data.list1;
                    this.visaTypeList = res.data.list2;
                })
                .catch((err) => {});
        },

        // 滚动加载
        loadData() {
            let $table = this.$refs.xTable;
            // 如果没选单位工程
            if (this.queryParams.treeIds?.length === 0) {
                $table ? $table.loadData([]) : "";
                return;
            }
            this.getTableData().then((data) => {
                if ($table) {
                    $table.loadData(data);
                }
            });
            this.$emit('onSuccess');
        },

        // 初始获得数据
        getTableData() {
            this.loading = true;
            let query = this.$utils.clone(this.queryParams, true);
            return new Promise((resolve) => {
                getVisaData(query)
                    .then((res) => {
                        this.loading = false;
                        // 保存全部数据
                        this.allTableData = res.data.list;
                        resolve(res.data.list);
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            });
        },

        // 获取表格数据
        getListData() {
            return this.$refs.xTable.getTableData().visibleData || []
        },

        // 切换 全部数据/异常数据
        changeData(showAll) {
            this.loading = true;
            this.queryParams.analysisType = 1;
            this.loadData();
        },

        // 打开列过滤弹窗
        openFilter() {
            this.dialogObj.title = "列过滤";
            this.dialogObj.type = "filter";
            this.dialogObj.visible = true;
        },

        // 确认过滤
        doFilter() {
            this.$refs.xTable.refreshColumn();
            this.handleClose()
        },

        // 列过滤全选事件
        handleAllChange(status, type) {
            this[type].map(x => {
                x.visible = status
            })
        },

        // 列过滤弹窗关闭
        handleClose() {
            this.dialogObj.visible = false;
            this.btnLoading = false;
        },

        // 表头点击事件
        onHeaderClick({ $rowIndex, column, columnIndex, $columnIndex, triggerResizable, triggerSort, triggerFilter, $event }) {
            this.curColumn = column.property;
        },

        // toFixed
        NumberToFixed(prop, digit) {
            let num = digit === 2 ? '0.00' : '0.000'
            return prop ? prop.toFixed(digit) : num
        },

        // 获取表格数据
        getListData() {
            return this.$refs.xTable.getTableData().visibleData || []
        },

        // 清除全部条件
        clearAll() {
            this.$refs.xTable.clearAll();
        },
    },
    computed: {
        // 项目ID
        curProjectId() {
            return this.$route.query.projectId;
        },

        // 获取选中的 phase的Type
        getPhaseObj() {
            let _item1 = this.visaTypeList.find((x) => x.value === this.visaType1)
            let _item2 = this.priceTypeList.find((x) => x.value === this.priceType2)

            let _name1 = _item1 ? _item1.name : ''
            let _name2 = _item2 ? _item2.name : ''

            return {
                type1: _item1 ? _item1.type : '',
                type2: _item2 ? _item2.type : '',
                name1: _name1,
                name2: _name2,
                nameStr: _name1 + ',' + _name2
            }
        },

        // 需要过滤的数据(材料名称， 单位)
        listData() {
            let _filter = this.compareArr1.filter((x) => x.needFilter);
            let _noFilter = this.compareArr1.filter((x) => !x.needFilter);
            let _filter2 = this.compareArr2.filter((x) => x.needFilter);
            let _noFilter2 = this.compareArr2.filter((x) => !x.needFilter);
            return {
                filterArr: _filter,
                normalArr: _noFilter,
                filterArr2: _filter2,
                normalArr2: _noFilter2,
                'str1.projectName': this.filterObj.names1,
                'str1.unit': this.filterObj.units1,
                'str2.projectName': this.filterObj.names2,
                'str2.unit': this.filterObj.units2,
            };
        },
    },
    watch: {
        // 监听复选框变化
        compareArr1: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare1 = !_false
            },
            deep: true
        },
        // 监听复选框变化
        compareArr2: {
            handler: function(arr) {
                let _false = arr.find(x => x.visible === false)
                this.checkAll.compare2 = !_false
            },
            deep: true
        },

        // 监听两个下拉选的变化
        visaType1(val) {
            this.queryParams.phase1 = this.visaType1;
            this.queryParams.phase2 = this.priceType2;
            this.loadData();
        },
        priceType2(val) {
            this.queryParams.phase1 = this.visaType1;
            this.queryParams.phase2 = this.priceType2;
            this.loadData();
        },
    }
};
</script>
<style scoped lang="less">
.check-row {
    margin-bottom: 7px;
    background-color: #a3e3ff;
    height: 35px;
    line-height: 35px;
    font-weight: 700;
    color: #333;

    .check-name {
        border-right: 1px solid #1d7f8a;
        text-align: right;
        padding-right: 15px;
    }

    .check-content {
        text-align: left;
        padding-left: 15px;
    }
}

.check-row:nth-of-type(2) {
    background-color: #f5f5ad;
}

.check-row:nth-of-type(3) {
    background-color: #ffe4c4;
}

.check-row:nth-of-type(4) {
    background-color: #7fffd4;
}

.blue-text {
    color: #2671cc;
}
</style>